import React from 'react';
import Grid from '@mui/material/Grid';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonDateRangePicker from 'pages/date/CommonDateRangePicker';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';

function CustomerBreadCrumb(props) {

  const breadcrumbPaths = [
  ];

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className='marginBlock0 marginTopBottom25'
      >
        <Grid item xs={5} md={3}>
          <CommonBreadCrumb paths={breadcrumbPaths}/>
        </Grid>

        <Grid
          item
          container
          xs={6}
          md={7.5}
          rowspacing={4}
          direction="row"
          justifyContent="end"
          alignItems="center"
        >
          <Grid item className='marginRight10' >
            <SearchBar  onSearch={props.onSearch}/>
          </Grid>
          {/* <Grid item>
          <CommonDateRangePicker onSelectDateRange={props?.onSelectDateRange} />
          </Grid> */}
          <Grid item className="filter_menu marginLeft18">
            <CommonFilter defaultStatus={props.defaultStatus} filterdata={props?.filterdata} onFilterChange={props?.onFilterChange} onRestFilter={props?.onRestFilter}/>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default CustomerBreadCrumb;
